module.exports = __webpack_public_path__ + "img/image01.4d06482e.jpg";